import {
  Anchor,
  Button,
  Container,
  Grid,
  Paper,
  Text,
  TextInput,
  Title,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { showNotification } from '@mantine/notifications';

import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';
import { Check, X } from 'tabler-icons-react';
import axios from '../../../api/axios';

import ExpiredResetLink from '../../../components/expired-reset-link/expired-reset-link.component';
import { ErrorResponse } from '../../../type/error-response.types';

const ResetPasswordPage = () => {
  const form = useForm({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    // validate: joiResolver(ForgetPasswordSchema),
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const token = query.get('token');
  const identifier = query.get('identifier');
  const [isValidResetToken, setIsValidResetToken] = useState(false);
  const [isComponentLoading, setIsComponentLoading] = useState(false);

  useEffect(() => {
    // const validateResetToken = async () => {
    //   try {
    //     setIsComponentLoading(true);
    //     const res = await axios.put('/web/auth/validate_reset_token', {
    //       token: token,

    //     });
    //     const isValid: boolean = res.data.value;
    //     setIsValidResetToken(isValid);
    //   } catch (err: any) {
    //     setIsValidResetToken(false);
    //   } finally {
    //     setIsComponentLoading(false);
    //   }
    // };

    // validateResetToken();
    // Static to true for now
    setIsValidResetToken(true);
  }, []);

  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      if (form.values.password != form.values.confirmPassword) {
        throw {
          message: "Passwords does not match."
        }
      }

      await axios.put('/web/auth/reset_password', {
        token: token,
        tokenIdentifier: identifier,
        password: form.values.password,
      });

      showNotification({
        id: 'successfully-reset-password',
        message: 'Successfully reset password.',
        icon: <Check size={16} />,
        color: 'teal',
        autoClose: 6000,
      });
      navigate('/login');
    } catch (err: any) {
      const error: ErrorResponse = err.response?.data;

      console.log("error: ", error);
      showNotification({
        id: 'failed-to-reset-password',
        message:
          error?.error || error || err.message || err || 'An Unexpected Error Occurred',
        icon: <X size={16} />,
        color: 'red',
        autoClose: 6000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>XPAY.World - Password reset</title>
      </Helmet>
      {isComponentLoading ? (
        <></>
      ) : !isValidResetToken ? (
        <ExpiredResetLink />
      ) : (
        <Container
          fluid
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100vh',
          }}
        >
          <Paper
            shadow='xs'
            p='xl'
            mx='auto'
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              maxWidth: 400,
            }}
          >
            {/* <Paper mb='sm'>
            <Image src='/images/lock-icon.svg' />
          </Paper> */}
            <Title order={2} mb='sm'>
              Reset Password
            </Title>
            <Text align='center' color='gray' size='sm' mb='sm'>
              Enter new password for your account
            </Text>
            <form onSubmit={form.onSubmit(handleSubmit)}>
              <Grid>
                <Grid.Col>
                  <TextInput
                    label='Password'
                    type='password'
                    placeholder='Password'
                    {...form.getInputProps('password')}
                  />
                </Grid.Col>
                <Grid.Col>
                  <TextInput
                    label='Confirm password'
                    type='password'
                    placeholder='Confirm password'
                    {...form.getInputProps('confirmPassword')}
                  />
                </Grid.Col>
                <Grid.Col>
                  <Button type='submit' loading={isLoading} fullWidth>
                    Submit
                  </Button>
                </Grid.Col>
                <Grid.Col>
                  <Anchor
                    component='button'
                    type='button'
                    color='gray'
                    onClick={() => {
                      navigate('/login');
                    }}
                    size='xs'
                  >
                    Back to login
                  </Anchor>
                </Grid.Col>
              </Grid>
            </form>
          </Paper>
        </Container>
      )}
    </>
  );
};

export default ResetPasswordPage;
